import { parseDomain } from '@wix/domains-serverless-interface';
import { usePremiumDomainPrices } from './usePremiumDomainPrices';
import { useTldPrices } from './useTldPrices';
export const useRowDisplayPrices = (recommendations, productType) => {
  const namedRows = recommendations.filter(row => Boolean(row.domain));
  const premiumDomains = namedRows.filter(_ref => {
    let premium = _ref.premium;
    return premium;
  }).map(_ref2 => {
    let domain = _ref2.domain;
    return domain;
  });
  const tldPricedDomains = namedRows.filter(_ref3 => {
    let premium = _ref3.premium;
    return !premium;
  }).map(_ref4 => {
    let domain = _ref4.domain;
    return {
      domain,
      tld: parseDomain(domain).tld
    };
  }).filter(_ref5 => {
    let tld = _ref5.tld;
    return Boolean(tld);
  });
  const premiumPrices = usePremiumDomainPrices(premiumDomains, productType);
  const tldPrices = useTldPrices(tldPricedDomains.map(_ref6 => {
    let tld = _ref6.tld;
    return tld;
  }), productType);
  const pricesByDomain = new Map(premiumPrices.pricesByDomain);
  tldPricedDomains.forEach(_ref7 => {
    let domain = _ref7.domain,
      tld = _ref7.tld;
    const price = tldPrices.pricesByTld.get(tld);
    if (price) {
      pricesByDomain.set(domain, price);
    }
  });
  return {
    pricesByDomain,
    isLoading: premiumPrices.isLoading || tldPrices.isLoading,
    pricesExcludeTax: tldPrices.pricesExcludeTax ?? premiumPrices.pricesExcludeTax
  };
};
//# sourceMappingURL=useRowDisplayPrices.js.map